import { Alert, Button, DatePicker, Form, message, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLoaderData, useNavigate } from "react-router";
import axiosInstance from "../common/api";
import { filterOption, requiredField } from "../common/common";
import FormPage from "../common/FormPage";

export default function EditAppointment() {
  const appointment = useLoaderData();
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [optionsLoading, setOptionsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    Promise.all([
      axiosInstance.get("employee", { params: { pageSize: 99999 } }),
      axiosInstance.get("appointmentType", { params: { pageSize: 99999 } }),
    ]).then(([employeesResponse, typesResponse]) => {
      if (active) {
        setEmployees(employeesResponse.data.data);
        setTypes(typesResponse.data.data);
      }
    }).catch(() => {
      if (active) setError("Impossibile caricare dipendenti e categorie. Ricarica la pagina.");
    }).finally(() => {
      if (active) setOptionsLoading(false);
    });
    return () => { active = false; };
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    setError(null);
    try {
      await axiosInstance.put(`appointment/${appointment.id}`, {
        employee: values.employee,
        type: values.type,
        date: values.date.format("YYYY-MM-DD"),
      });
      message.success("Nomina modificata con successo");
      navigate(`/appointments/${appointment.id}`);
    } catch {
      setError("Salvataggio non riuscito. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormPage key={appointment.id} title="Modifica nomina" onFinish={onFinish} initialValues={{
      employee: appointment.employee.id,
      type: appointment.appointmentType.id,
      date: appointment.date ? dayjs(appointment.date) : null,
    }}>
      {error && <Alert type="error" showIcon title={error} style={{ marginBottom: 16 }} />}
      <Form.Item name="employee" label="Dipendente" rules={[requiredField]}>
        <Select showSearch filterOption={filterOption} loading={optionsLoading}
          options={employees.map((employee) => ({ label: employee.fullName, value: employee.id }))} />
      </Form.Item>
      <Form.Item name="type" label="Categoria" rules={[requiredField]}>
        <Select showSearch filterOption={filterOption} loading={optionsLoading}
          options={types.map((type) => ({ label: type.name, value: type.id }))} />
      </Form.Item>
      <Form.Item name="date" label="Data" rules={[requiredField]}>
        <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Button htmlType="submit" type="primary" loading={loading} disabled={optionsLoading}>Salva</Button>
      </Form.Item>
    </FormPage>
  );
}
